import et from './et.json'

const translations = {
    et,
}

export default translations